<template>
  <div class="device">
    <a-spin :spinning="spinning">
    <!-- ----------------- -->
    <div class="device-title">
      设备管理
    </div>
    <!-- 搜索 -->
    <div class="serach-warp">
      <div class="margin-right-15" style="display: inline-block;vertical-align: top;">
        <search @onSearch="onSearch" placeholder="请输入出厂编码或站点编码或设备编码或IMEI或蓝牙名称或地理位置搜索" />
      </div>
      <div style="display: inline-block;vertical-align: top;">
        <a-button  v-if="hasPerm('/device/addDeviceVptinfo')" class="createrBtn" @click="showCreateClick">创建设备</a-button>
      </div>
    </div>
    <div class="serach-warp" style="color:#33CCE0">
      请输入出厂编码或站点编码或设备编码或IMEI或蓝牙名称或地理位置搜索
    </div>
    <!-- 表格 -->
    <device-table ref="deviceTable" />
    <!-- 创建设备 -->
    <a-modal v-model="visible"
            :mask="true"
            :centered="true"
            :footer="null"
            :maskClosable="true"
    >
      <div class="createTitle">创建设备</div>
      <a-form-model ref="createDevice" v-bind="layout" :model="createDeviceForm" :rules="createDeviceFormRules">
        <a-form-model-item has-feedback label="出厂编码" prop="deviceNum">
          <a-input v-model="createDeviceForm.deviceNum" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="站点编码" prop="vptCode">
          <a-input v-model="createDeviceForm.vptCode" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="设备编码" prop="vptNum">
          <a-input v-model="createDeviceForm.vptNum" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="IMEI" prop="name">
          <a-input v-model="createDeviceForm.name" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="设备类型" prop="deviceType">
          <a-radio-group v-model="createDeviceForm.deviceType">
            <a-radio :value="1">RTU</a-radio>
            <a-radio :value="2">电子锁</a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item has-feedback label="地理位置" prop="pos">
          <a-input v-model="createDeviceForm.pos" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="控制指令" prop="cmd">
          <a-input v-model="createDeviceForm.cmd" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="设备状态" prop="state">
          <a-radio-group v-model="createDeviceForm.state">
            <a-radio :value="0" :checked="true">
              关
            </a-radio>
            <a-radio :value="1">
              开
            </a-radio>
          </a-radio-group>
        </a-form-model-item>

        <a-form-model-item has-feedback label="蓝牙名称" prop="nameB">
          <a-input v-model="createDeviceForm.nameB" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="SIM卡号" prop="ccidB">
          <a-input v-model="createDeviceForm.ccidB" type="text" autocomplete="off" />
        </a-form-model-item>
<!--        <a-form-model-item has-feedback label="广播名称" prop="localNameB">-->
<!--          <a-input v-model="createDeviceForm.localNameB" type="text" autocomplete="off" />-->
<!--        </a-form-model-item>-->

<!--        <a-form-model-item has-feedback label="物理地址" prop="deviceIdB">-->
<!--          <a-input v-model="createDeviceForm.deviceIdB" type="text" autocomplete="off" />-->
<!--        </a-form-model-item>-->

        <a-form-model-item has-feedback label="IMEI编码" prop="imeiB">
          <a-input v-model="createDeviceForm.imeiB" type="text" autocomplete="off" />
        </a-form-model-item>

        <a-form-model-item has-feedback label="蓝牙备注" prop="remarkB">
          <a-input v-model="createDeviceForm.remarkB" type="text" autocomplete="off" />
        </a-form-model-item>
      </a-form-model>

      <div class="btn-wrap">
        <a-button class="cancel margin-right-15" @click="cancel">取消</a-button>
        <a-button class="create" @click="submitForm('createDevice')">创建</a-button>
      </div>

    </a-modal>
    </a-spin>
  </div>
</template>

<script>
import { addDevice } from "api/device"

import search from "@/components/content/search/Search";
import DeviceTable from './childComps/DeviceTable';
import {hasPermission} from 'utils/hasPermission'

export default {
  name: 'Device',
  components: {
    search,
    DeviceTable
  },
  data() {
    let checkPending;
    let validateVptNum = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('设备编码不能为空'));
      } else {
        callback();
      }
    };
    let validateName = (rule, value, callback) => {
      if (!value || value === '') {
        callback(new Error('IMEI不能为空'));
      } else {
        callback();
      }
    };
    let validateDeviceType = (rule, value, callback) => {
      if (value !== 1 && value !== 2) {
        callback(new Error('请选择设备类型'));
      } else {
        callback();
      }
    };
    // let validateNameB = (rule, value, callback) => {
    //   if (!value || value === '') {
    //     callback(new Error('蓝牙名称不能为空'));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      spinning: false,
      layout: {
        labelCol: { span: 4 },
        wrapperCol: { span: 20 },
      },
      visible: false,

      createDeviceForm: {
        cmd: null,
        cmdDate: null,
        name: "",
        pos: "",
        state: 0,
        deviceType: undefined,
        deviceNum: "",
        vptNum: "",
        vptCode: "",
        nameB: "",
        localNameB: "",
        deviceIdB: "",
        imeiB: "",
        remarkB: "",
        ccidB: "",
      },

      createDeviceFormRules: {
        vptNum: [{validator: validateVptNum, trigger: 'change'}],
        name: [{validator: validateName, trigger: 'change'}],
        deviceType: [{validator: validateDeviceType, trigger: 'change'}],
        // nameB: [{validator: validateNameB, trigger: 'change'}]
      },
      searchValue:''
    }
  },
  methods: {
    hasPerm(perm){
      return hasPermission(perm);
    },
    /**
    * 逻辑区
    */
    // 加载动画
    loading() {
      this.spinning = !this.spinning
    },
    // 搜索
    onSearch(value) {
      this.searchValue = value
      this.$refs.deviceTable.onSearch(value)
    },
    // 显示创建设备
    showCreateClick() {
      this.createDeviceForm = {
        cmd: null,
        cmdDate: null,
        name: "",
        pos: "",
        state: 0,
        deviceType: undefined,
        deviceNum: "",
        vptNum: "",
        vptCode: "",
        nameB: "",
        localNameB: "",
        deviceIdB: "",
        imeiB: "",
        remarkB: "",
        ccidB: "",
      }
      this.visible = !this.visible;
    },
    // 取消创建
    cancel() {
      console.log("取消创建");
      this.visible = !this.visible;
    },
    // 创建设备
    submitForm(formName) {
      const vm = this;
      this.$refs[formName].validate(valid => {
        if (valid) {
          vm.create()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    /**
    * 接口区
    */
    create() {
      const vm = this;
      this.spinning = true
      let objectid = vm.createDeviceForm.objectid
      let deviceNum = vm.createDeviceForm.deviceNum
      let vptCode = vm.createDeviceForm.vptCode
      let vptNum = vm.createDeviceForm.vptNum
      let name = vm.createDeviceForm.name
      let pos = vm.createDeviceForm.pos
      let state = vm.createDeviceForm.state
      let cmd = vm.createDeviceForm.cmd
      let nameB = vm.createDeviceForm.nameB
      let localNameB = vm.createDeviceForm.localNameB
      let deviceIdB = vm.createDeviceForm.deviceIdB
      let imeiB = vm.createDeviceForm.imeiB
      let ccidB = vm.createDeviceForm.ccidB
      let remarkB = vm.createDeviceForm.remarkB
      let deviceType = vm.createDeviceForm.deviceType

      addDevice(objectid,vptNum,name,pos,state,cmd,nameB,localNameB,deviceIdB,imeiB,remarkB,ccidB,deviceNum,vptCode,deviceType)
        .then(res => {
          console.log(res);
          this.spinning = false
          if(res.code != "0") {
            this.$message.error(res.message);
          } else {
            this.$message.success('创建设备成功！');
            this.$refs.deviceTable.deviceName = this.searchValue;
            this.$refs.deviceTable.getDeviceListData(0, this.pageSize, this.searchValue)
            this.visible = !this.visible;
          }
        })
        .catch(err => {
          vm.spinning = false
          console.log(err);
          this.$message.error(err.message);
        })
    }
  }
}
</script>

<style lang='scss' scoped>
  .device {
    .device-title {
      font-size: 30px;
      font-weight: 500;
      color: #131212;
    }
    .serach-warp {
      margin: 15px 0;
      .createrBtn {
        color: #fff;
        background-color: #33CCE0;
      }
    }
  }

  .createTitle {
    line-height: 45px;
    font-size: 28px;
    font-weight: 500;
    text-align: center;
    color: #131212;
    margin-bottom: 30px;
  }
  .btn-wrap {
    text-align: center;
    margin-top: 10px;
    .create {
      color: #fff;
      background-color: #33CCE0;
    }
  }
</style>
